export default "__VITE_ASSET__CZAKOxKj__"